'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/charts/Chart.PolarArea.js
// module id = 775
// module chunks = 4